const PREFERENCE_KEY = "nuts-pedidos-digitais-som";

export function readSoundPreference() {
  try {
    return window.localStorage.getItem(PREFERENCE_KEY) !== "off";
  } catch (_) {
    return true;
  }
}

export function saveSoundPreference(enabled) {
  try {
    window.localStorage.setItem(PREFERENCE_KEY, enabled ? "on" : "off");
  } catch (_) {
    /* O som funciona mesmo quando o armazenamento esta bloqueado. */
  }
}

export function createOrderSound() {
  let context = null;
  let closed = false;
  let playingUntil = 0;
  const oscillators = new Set();
  const stop = () => {
    oscillators.forEach((oscillator) => {
      try {
        oscillator.stop();
      } catch (_) {
        /* A nota pode ja ter terminado. */
      }
    });
    oscillators.clear();
    playingUntil = context ? context.currentTime : 0;
  };
  return {
    stop,
    async unlock() {
      if (closed) return false;
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return false;
        if (!context) context = new AudioContext();
        if (context.state !== "running") await context.resume();
        return !closed && context.state === "running";
      } catch (_) {
        return false;
      }
    },
    play() {
      if (closed || !context || context.state !== "running") return false;
      // Repete a campainha por cerca de sete segundos para dar tempo de
      // perceber o pedido mesmo em um ambiente de cozinha movimentado.
      const start = Math.max(context.currentTime, playingUntil);
      Array.from({ length: 4 }, () => [784, 988, 1175, 784, 988, 1175])
        .flat()
        .forEach((frequency, index) => {
          const at = start + Math.floor(index / 6) * 1.75 + (index % 6) * 0.22;
          const oscillator = context.createOscillator();
          const gain = context.createGain();
          oscillator.type = "sine";
          oscillator.frequency.value = frequency;
          gain.gain.setValueAtTime(0, at);
          gain.gain.linearRampToValueAtTime(0.25, at + 0.015);
          gain.gain.exponentialRampToValueAtTime(0.001, at + 0.2);
          oscillator.connect(gain);
          gain.connect(context.destination);
          oscillators.add(oscillator);
          oscillator.onended = () => {
            oscillators.delete(oscillator);
            oscillator.disconnect();
            gain.disconnect();
          };
          oscillator.start(at);
          oscillator.stop(at + 0.22);
        });
      playingUntil = start + 7;
      return true;
    },
    close() {
      closed = true;
      stop();
      if (context && context.state !== "closed")
        context.close().catch(() => {});
    },
  };
}
